var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-group',{attrs:{"invalid-feedback":_vm.firstErrorMessage,"state":_vm.isValid,"label":_vm.label}},[_vm._t("default",null,{"attrs":{ state: _vm.isValid },"listeners":{
      input: () => _vm.preferredValidator.$touch(),
      focus: () => _vm.preferredValidator.$touch(),
    }}),(_vm.helptext)?_c('b-form-text',[_vm._v(" "+_vm._s(_vm.helptext)+" ")]):_vm._e(),(
      !('required' in _vm.preferredValidator) &&
        !('sameAsPassword' in _vm.preferredValidator)
    )?_c('b-form-text',[_vm._v(_vm._s(_vm.$t('optional'))+"\n  ")]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }